<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单列表
  -->
  <!-- 搜索框 -->
  <div class="user">
    <div style="margin-bottom: 15px">
      <el-button type="success" @click="shuaixn()">刷新</el-button>
      <el-button type="danger">逾期总金额 {{ money(yqprice) }}</el-button>
    </div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="会员信息">
          <el-input v-model="searchForm.search" placeholder="真实姓名|手机号|身份证"></el-input>
        </el-form-item>
        <el-form-item label="订单号"><el-input size="small" v-model="searchForm.order_no"
            placeholder="请输入订单号"></el-input></el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.create_time" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button size="small" type="primary" icon="el-icon-search"
            @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>

    <!-- 表格数据 -->
    <el-table :data="tableData.data" style="width: 100%">
      <el-table-column label="ID" width="50">
        <template slot-scope="scope">
          {{ scope.row.order_id }}
        </template>
      </el-table-column>

      <el-table-column label="订单号" width="150">
        <template slot-scope="scope">
          {{ scope.row.order_no }}
        </template>
      </el-table-column>

      <el-table-column label="订单信息" width="200">
        <template slot-scope="scope">
          <div class="product-info" v-for="(item, index) in scope.row.product" :key="index">
            <span>{{ item.product_name.slice(0, 18) }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="总期数">
        <template slot-scope="scope">
          1/{{ scope.row.order_bill[0].Total_number_of_periods }}
        </template>
      </el-table-column>

      <el-table-column label="租金(元)">
        <template slot-scope="scope">
          <div>￥{{ scope.row.order_bill[0].price }}</div>
        </template>
      </el-table-column>

      <el-table-column label="支付状态">
        <template slot-scope="scope">
          <p class="dot"></p>
          <span style="color: red; font-weight: bold">
            {{ scope.row.yq_pay_status == 2 ? "未支付" : "-" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="支付时间" width="70">
        <template slot-scope="scope">
          <div v-if="scope.row.zfsj > 0">
            {{ scope.row.zfsj | formatDate }}
          </div>

          <div v-else style="text-align: center">-</div>
        </template>
      </el-table-column>

      <el-table-column label="逾期期数" width="70">
        <template slot-scope="scope">
          <span class="yuqicolor">{{ scope.row.qishu }} </span> 期
        </template>
      </el-table-column>

      <el-table-column label="逾期天数" width="70">
        <template slot-scope="scope">
          <span class="yuqicolor">{{ scope.row.wysj }} </span> 天
        </template>
      </el-table-column>

      <el-table-column label="本期还租时间" width="150">
        <template slot-scope="scope">
          {{ scope.row.bqhz | formatDate }}
        </template>
      </el-table-column>

      <el-table-column label="姓名">
        <template slot-scope="scope">
          {{ scope.row.username }}
        </template>
      </el-table-column>

      <el-table-column label="备注" width="350">
        <template slot-scope="scope">
          <div>{{ scope.row.zuhoutip }}</div>
        </template>
      </el-table-column>

      <el-table-column label="法律状态" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.flzt == '正常'" style="color: #2c3e50">
            <p class="dotzc"></p>
            {{ scope.row.flzt }}
          </div>
          <div v-else-if="scope.row.flzt == '失联'" style="color: #18bc9c">
            <p class="dotg"></p>
            {{ scope.row.flzt }}
          </div>
          <div v-else-if="scope.row.flzt == '律师函已发'" style="color: #d154e9">
            <p class="dotz"></p>
            {{ scope.row.flzt }}
          </div>
          <div v-else-if="scope.row.flzt == '起诉'" style="color: #f39c12">
            <p class="doty"></p>
            {{ scope.row.flzt }}
          </div>
          <div v-else-if="scope.row.flzt == '约定还款时间'" style="color: #3498db">
            <p class="dotb"></p>
            {{ scope.row.flzt }}
          </div>
          <div v-else-if="scope.row.flzt == '部分已还'" style="color: #d2d6de">
            <p class="doth"></p>
            {{ scope.row.flzt }}
          </div>
          <div v-else-if="scope.row.flzt == '关机'" style="color: #e74c3c">
            <p class="dotr"></p>
            {{ scope.row.flzt }}
          </div>
          <div v-else-if="scope.row.flzt == '通话中未接拒绝'" style="color: #f39c12">
            <p class="doty"></p>
            {{ scope.row.flzt }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="订单类型">
        <template slot-scope="scope">
          <span class="yuqi"> 已逾期 </span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="400" fixed="right">
        <template slot-scope="scope">
          <div style="display: flex">
            <el-button @click="addClick(scope.row)" type="info" size="small">订单详情</el-button>
            <el-button @click="gohuankuan(scope.row)" type="primary" size="small">还款详情</el-button>
            <el-button @click="gofengkong(scope.row)" type="success" size="small"
              style="margin-right: 10px">备注</el-button>
            <el-dropdown split-button type="primary">
              更多
              <el-dropdown-menu slot="dropdown">
                <div style="
                    display: flex;
                    flex-direction: column;
                    padding: 5px 10px;
                  ">
                  <el-button @click="weiyuej(scope.row)" type="text">终止合同</el-button>
                  <el-button @click="weiyuej2(scope.row)" type="text">逾期违约金/天</el-button>
                  <el-button @click="gosdkk(scope.row)" type="text">手动扣款</el-button>
                  <el-button @click="goqxyh(scope.row)" type="text" style="margin-top: 5px">取消/已还</el-button>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
        :current-page="curPage" :page-sizes="[10, 20, 50, 100]" :page-size="10"
        layout="total, prev,sizes ,pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>

    <!-- 违约金催收弹窗-->
    <el-dialog title="违约金催收" :visible.sync="dialogVisibleWYJ" width="55%">
      <div style="margin-top: 20px; display: flex; align-items: center">
        <div style="width: 50%; font-size: 24px">
          违约金额:{{ wyjprice }} 元
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleWYJ = false">取 消</el-button>
        <el-button type="primary" @click="quedingWYJ()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 违约金催收弹窗-->
    <el-dialog title="违约金催收" :visible.sync="dialogVisibleWYJ2" width="55%">
      <div style="margin-top: 20px; display: flex; align-items: center">
        <div style="width: 50%; font-size: 24px">
          违约金额:{{ wyjprice }} 元
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleWYJ2 = false">取 消</el-button>
        <el-button type="primary" @click="quedingWYJ2()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 备注弹窗-->
    <el-dialog title="备注" :visible.sync="dialogVisible5" width="30%">
      <div style="margin-top: 20px; display: flex; align-items: center">
        <div style="width: 14%">备注:</div>
        <el-input v-model="bzfrom.inputbeizhu" placeholder="请输入备注信息" style="margin-top: 10px"></el-input>
      </div>

      <div style="margin-top: 20px; display: flex; align-items: center">
        <div style="margin-right: 15px">法律状态:</div>
        <el-select v-model="bzfrom.inputfl" placeholder="请选择">
          <el-option v-for="item in flztlist" :key="item.val" :label="item.name" :value="item.name">
          </el-option>
        </el-select>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible5 = false">取 消</el-button>
        <el-button type="primary" @click="queding5()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 还款详情弹窗 -->
    <el-dialog title="还款详情" :visible.sync="dialogTableVisible">
      <el-table :data="gridData">
        <el-table-column property="bill_id" label="租期ID"></el-table-column>
        <el-table-column property="current_period" label="期数"></el-table-column>
        <el-table-column property="price" label="应还款金额"></el-table-column>
        <el-table-column label="还款时间">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{
              scope.row.repayment_date | formatDate
            }}</span>
          </template>
        </el-table-column>

        <el-table-column label="是否已经还">
          <template slot-scope="scope">
            <template v-if="scope.row.is_pay_status == 0">
              <span style="margin-left: 10px; color: #ff0000">未还</span>
            </template>
            <template v-else-if="scope.row.is_pay_status == 1">
              <span style="margin-left: 10px; color: cornflowerblue">已还</span>
            </template>
            <template v-else-if="scope.row.is_pay_status == 2">
              <span style="margin-left: 10px">逾期</span>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 取消/已还弹框 -->
    <el-dialog title="取消/已还" :visible.sync="dialogTableVisiblequxiao">
      <div style="text-align: center">
        <p style="color: red; font-size: 18px">
          该笔租期已还/取消该笔扣款前请确认以下信息！该笔操作取消后不可扣款！请谨慎操作！！！
        </p>
        <div style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 20px 0;
          ">
          <p style="width: 15%">取消原因:</p>
          <el-input v-model="inputnr" placeholder="请输入内容"></el-input>
        </div>
        <table border="1" style="border-collapse: collapse; width: 100%">
          <tr>
            <th>姓名 <span></span></th>
            <th>支付宝交易号<span></span></th>
            <th>订单号<span></span></th>
            <th>期数<span></span></th>
            <th>金额<span></span></th>
            <th>已扣款金额<span></span></th>
            <th>未扣款金额<span></span></th>
            <th>本期应还款时间<span></span></th>
          </tr>

          <tr v-if="ddInfo">
            <th>
              <span> {{ ddInfo.username }} </span>
            </th>
            <th>
              <span> {{ ddInfo.order_no }} </span>
            </th>
            <th>
              <span> {{ ddInfo.order_id }} </span>
            </th>
            <th>
              <span> {{ ddInfo.current_period }} </span>
            </th>
            <th>
              <span> {{ ddInfo.price }} </span>
            </th>
            <th>
              <span>
                {{ ddInfo.is_pay_status == 1 ? ddInfo.price : "" }}
              </span>
            </th>
            <th>
              <span>
                {{ ddInfo.is_pay_status == 0 ? ddInfo.price : "" }}
                {{ ddInfo.is_pay_status == 2 ? ddInfo.price : "" }}</span>
            </th>
            <th>
              <span> {{ ddInfo.repayment_date }} </span>
            </th>
          </tr>
        </table>

        <div class="anniu">
          <el-button @click="dialogTableVisiblequxiao = false">取 消</el-button>
          <el-button type="primary" @click="quedingqx()">确 定</el-button>
        </div>
      </div>
    </el-dialog>

    <Logistics :logisticsData="logisticsData" :isLogistics="isLogistics" @closeDialog="closeLogistics">
    </Logistics>
  </div>
</template>

<script>
import store from "@/store/";
import AuthApi from "@/api/auth.js";
import OrderApi from "@/api/order.js";
import { timeFormat } from "@/utils/timeFormat";
import FengkongApi from "@/api/fengkong.js";
import Logistics from "@/components/logistics/viewLogistics.vue";
import qs from "qs";
export default {
  name: "Login",
  components: {
    Logistics,
  },
  computed: {
    money() {
      return function (num) {
        if (num) {
          return num.toFixed(2);
        } else {
          return 0.00
        }
      };
    }
  },
  data() {
    return {
      bzfrom: {
        inputbeizhu: "", //备注信息
        inputfl: "", //法律状态
      },
      //  法律状态信息
      flztlist: [
        {
          name: "正常",
          val: 1,
        },
        {
          name: "失联",
          val: 2,
        },
        {
          name: "律师函已发",
          val: 3,
        },
        {
          name: "起诉",
          val: 4,
        },
        {
          name: "约定还款时间",
          val: 5,
        },
        {
          name: "部分已还",
          val: 6,
        },
        {
          name: "关机",
          val: 7,
        },
        {
          name: "通话中未接拒绝",
          val: 8,
        },
      ],

      yqprice: "",
      inputnr: "",
      dialogTableVisiblequxiao: false,
      ddInfo: "",
      dialogVisible5: false,
      gridData: "",
      dialogTableVisible: false,
      //预交金额
      yushou: "",
      //已还金额
      qian1: "",
      //期数
      qishu: "",
      //逾期总金额
      total_price: "",
      //逾期期数
      yuqi: "",
      //租赁开始时间
      create_time1: "",
      yuqijine: "",
      // 时间格式化
      time: "",
      // 十位数 时间戳
      timeTemp: "",
      // 十三位数 时间戳
      timesTemp: "",
      zujin: "",
      shop_url: "",
      htdata: "",
      // 签署id
      folwid: "",
      //碎屏险
      radio: "2",
      // order_id 订单id
      order_id: "",
      remarksText: "",
      remarksText1: "",
      // 输入框值
      yushou: "",
      // 租期列表
      zqlist: "",
      /*显示弹框*/
      dialogVisible: false,
      /*切换菜单*/
      activeName: "all",
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        search: "",
        order_no: "",
        style_id: "",
        create_time: "",
        total_price: "",
      },
      /*时间*/
      create_time: "",
      create_time1: "",
      total_price: "",

      isLogistics: false,
      logisticsData: {},
      wyjprice: "", //违约金金额
      dialogVisibleWYJ: false, //type = 1
      bill_id: null,
      dialogVisibleWYJ2: false, //type = 2
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    // 违约金确定
    quedingWYJ() {
      OrderApi.tongzhi({ bill_id: this.bill_id, type: 1 }, true)
        .then((data) => {
          // console.log("成功返回的data", data.data.price);
          this.dialogVisibleWYJ = false;
          this.$message({
            type: "success",
            message: "操作成功",
          });
        })
        .catch((error) => { });
    },
    //违约金弹窗
    weiyuej(row) {
      let self = this;
      let fordata = row.order_bill;
      for (const item of fordata) {
        if (item.is_pay_status == "2") {
          self.bill_id = item.bill_id;
        }
      }
      OrderApi.tongzhi2({ bill_id: self.bill_id, type: 1 }, true)
        .then((data) => {
          console.log("成功返回的data", data.data.price);
          self.wyjprice = data.data.price;
          self.dialogVisibleWYJ = true;
        })
        .catch((error) => { });
    },

    // 违约金2确定
    quedingWYJ2() {
      OrderApi.tongzhi({ bill_id: this.bill_id, type: 2 }, true)
        .then((data) => {
          // console.log("成功返回的data", data.data.price);
          this.dialogVisibleWYJ2 = false;
          this.$message({
            type: "success",
            message: "操作成功",
          });
        })
        .catch((error) => { });
    },

    //违约金2弹窗
    weiyuej2(row) {
      let fordata = row.order_bill;
      for (const item of fordata) {
        if (item.is_pay_status == "2") {
          this.bill_id = item.bill_id;
        }
      }
      OrderApi.tongzhi2({ bill_id: this.bill_id, type: 2 }, true)
        .then((data) => {
          this.wyjprice = data.data.price;
          this.dialogVisibleWYJ2 = true;
        })
        .catch((error) => { });
    },

    /*获取列表*/
    async getData() {
      let self = this;
      self.loading = true;
      // let resp = await AuthApi.userList(Params, true);
      // let datainfo = resp.data.list.data;
      // for (let item of datainfo) {
      //   if (item.role_id == 4 && shop_user_id == item.shop_user_id ) {
      //     self.searchForm.tuiguang_id = item.shop_user_id;
      //   } else {
      //     self.searchForm.tuiguang_id = "";
      //   }
      // }
      let Params = this.searchForm;
      var resp = await store.dispatch("common/getBaseInfo");
      if (resp.role != "") {
        if (resp.role[0].role_id == 4) {
          Params.tuiguang_id = Params.tuiguang_id;
        }
      } else {
        Params.tuiguang_id = "";
      }
      Params.dataType = self.activeName;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      OrderApi.orderlist4(Params, true)
        .then((res) => {
          self.totalDataNumber = res.data.list.total;
          self.tableData = res.data.list;
          self.yqprice = res.data.yqprice
          let fordata = res.data.list.data;
          for (let item in fordata) {
            for (
              let index = 0;
              index < fordata[item].order_bill.length;
              index++
            ) {
              if (fordata[item].order_bill[index].is_pay_status == 2) {
                self.tableData.data[item].bqhz =
                  fordata[item].order_bill[index].repayment_date;
                self.tableData.data[item].zfsj =
                  fordata[item].order_bill[index].paytime;
                self.tableData.data[item].yq_pay_status =
                  fordata[item].order_bill[index].is_pay_status;
                break;
              }
            }
          }

          for (let i = 0; i < res.data.list.data.length; i++) {
            let item = res.data.list.data[i];
            let wysj = 0;
            let qishu = 0;
            for (let j = 0; j < item.order_bill.length; j++) {
              let data = item.order_bill[j];
              if (data.is_pay_status == 2) {
                //逾期天数
                let d1 = data.repayment_date * 1000;
                let d2 = Date.parse(new Date());
                // console.log("d1",d1,"d2",d2);
                let time = d2 - d1;
                // console.log("time",time);
                wysj += time;
                // console.log(wysj);
                break;
              }
            }

            for (let j = 0; j < item.order_bill.length; j++) {
              let data = item.order_bill[j];
              if (data.is_pay_status == 2) {
                //逾期期数
                qishu += 1;
              }
            }
            item.qishu = qishu;
            item.wysj = Math.trunc(wysj / (1000 * 60 * 60 * 24));

            self.tableData.data[i] = item;
            self.loading = false;
          }
        })
        .catch((error) => { });
    },

    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getData();
    },

    // 取消/已还确定
    quedingqx() {
      let Params = {
        order_id: this.ddInfo.order_id,
        current_period: this.ddInfo.current_period,
      };
      FengkongApi.cancelDaikou(Params, true)
        .then((res) => {
          this.dialogTableVisiblequxiao = false;
          this.getData();
        })
        .catch((error) => { });
    },
    // 手动扣款
    gosdkk(row) {
      this.ddInfo = row;
      this.$confirm("进行手动扣款操作?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info ",
      })
        .then(() => {
          let Params = {
            order_id: this.ddInfo.order_id,
            current_period: this.ddInfo.current_period,
          };
          FengkongApi.withholdingTrigger(Params, true)
            .then((res) => {
              // this.$message({
              //   type: 'success',
              //   message: '操作成功'
              // });
              this.getData();
            })
            .catch((error) => { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 显示取消/已还
    goqxyh(row) {
      console.log(row);
      this.ddInfo = row;
      this.dialogTableVisiblequxiao = true;
    },
    // 备注确定
    queding5() {
      let Params = {
        order_id: this.order_id,
        flzt: this.bzfrom.inputfl,
        zuhoutip: this.bzfrom.inputbeizhu,
      };
      console.log(Params);
      OrderApi.zhflzt(Params, true)
        .then((data) => {
          console.log("成功返回的data", data);
          this.$message({
            message: data.msg,
            type: "success",
          });
          this.getData();
          this.dialogVisible5 = false;
        })
        .catch((error) => { });
    },
    // 备注显示
    gofengkong(row) {
      this.bzfrom.inputfl = row.flzt;
      this.bzfrom.inputbeizhu = row.zuhoutip;
      this.dialogVisible5 = true;
      this.order_id = row.order_id;
    },
    //  刷新
    shuaixn() {
      this.loading = true;
      this.getData();
    },
    // 还款详情
    gohuankuan(row) {
      this.dialogTableVisible = true;
      console.log("还款", row);
      let Params = {
        order_id: row.order_id,
      };
      OrderApi.zuqi(Params, true)
        .then((res) => {
          this.gridData = res.data.billList;
        })
        .catch((error) => { });
    },
    /*订单详情*/
    addClick(row) {
      let self = this;
      let params = row.order_id;
      // self.$router.push({
      //   path: '/order/order/Detail',
      //   query: {
      //     order_id: params
      //   }
      // });
      let routeData = self.$router.resolve({
        path: "/order/order/Detail",
        query: { order_id: params },
      });
      window.open(routeData.href, "_blank");
    },
    getLogistics(row) {
      let self = this;
      let Params = {
        order_id: row.order_id,
      };
      // self.loading = true;
      OrderApi.queryLogistics(Params, true)
        .then((res) => {
          self.logisticsData = res.data.express.list;
          self.loading = false;
          console.log(self.logisticsData);
          self.openLogistics();
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    openLogistics() {
      this.isLogistics = true;
    },
    closeLogistics() {
      this.isLogistics = false;
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
    onExport: function () {
      let baseUrl = window.location.protocol + "//" + window.location.host;
      window.location.href =
        baseUrl +
        "/index.php/shop/order.operate/export?" +
        qs.stringify(this.searchForm);
    },
  },
  filters: {
    // 过滤器
    formatDate(create_time1) {
      let date = new Date(create_time1 * 1000);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s; //年月日时分秒
    },
  },
};
</script>
<style lang="scss">
.user {
  height: 1000px;
}

.yuqicolor {
  color: red;
}

.dotz {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #d154e9;
}

.dotzc {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #2c3e50;
}

.doth {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #d2d6de;
}

.dotr {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #e74c3c;
}

.dotb {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #3498db;
}

.dotg {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #18bc9c;
}

.doty {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #f39c12;
}

.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: #2c3e50;
}

.yuqi {
  display: inline;
  padding: 0.2em 0.6em 0.3em;
  font-size: 75%;
  font-weight: bold;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
  background-color: #e74c3c;
}

.d1 {
  width: 100px;
  list-style: none;
  border: 1px solid #ffa49f;
  padding: 5px;
  background-color: #fff1f0;
  color: #f6363e;
  border-radius: 10px;
  text-align: center;
  margin: 25px 0;
}

.anniu {
  margin-bottom: 2px;
}

.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}

.yizhifu {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/yqindex.vue